import { AccessLevel } from '@colonist/types';
export function isValueTrue(value) {
    return value === true;
}
export function isValueBoolean(value) {
    return typeof value === 'boolean';
}
export function isValueNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value) && Number.isFinite(value);
}
export function isValueNullish(value) {
    if (value === undefined) return true;
    if (value === null) return true;
    return false;
}
export function isValueNumberArray(value) {
    return Array.isArray(value) && value.every(isValueNumber);
}
export function isValueNumberBetween(value, minValue, maxValue) {
    return isValueNumber(value) && value >= minValue && value <= maxValue;
}
export function isValueString(value) {
    return typeof value === 'string';
}
export function isValueNonEmptyString(value) {
    return isValueString(value) && value != '';
}
export function isValueStringBetween(value, minLength, maxLength) {
    return isValueString(value) && isValueNumberBetween(value.length, minLength, maxLength);
}
export function isValueNumericEnum(value, theEnum) {
    if (!isValueNumber(value)) return false;
    if (theEnum[value] == undefined) return false;
    return true;
}
export function isValueNumericEnumArray(value, theEnum) {
    return Array.isArray(value) && value.every((v)=>isValueNumericEnum(v, theEnum));
}
export function isValueEmail(value) {
    // https://ui.dev/validate-email-address-javascript/
    return isValueString(value) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
export function isValueRequiredAccessLevel(value, requiredAccessLevel) {
    const reqACLAdmin = requiredAccessLevel == AccessLevel.Administrator;
    const reqACLManager = requiredAccessLevel == AccessLevel.Manager;
    const reqACLModerator = requiredAccessLevel == AccessLevel.Moderator;
    const reqACLUser = requiredAccessLevel == AccessLevel.User;
    switch(value){
        case undefined:
            return false;
        case AccessLevel.Administrator:
            if (reqACLAdmin || reqACLManager || reqACLModerator || reqACLUser) return true;
            break;
        case AccessLevel.Manager:
            if (reqACLManager || reqACLModerator || reqACLUser) return true;
            break;
        case AccessLevel.Moderator:
            if (reqACLModerator || reqACLUser) return true;
            break;
        case AccessLevel.User:
            if (reqACLUser) return true;
            break;
    }
    return false;
}
export function isValueDate(value) {
    if (value instanceof Date && !isNaN(value.getTime())) return true;
    if (isValueString(value) && !isNaN(Date.parse(value))) return true;
    return false;
}
export function isValuePlainObject(value) {
    if (typeof value !== 'object') return false;
    if (Array.isArray(value)) return false;
    return true;
}
export function isValueArray(value) {
    return Array.isArray(value);
}
export function isValueFile(value) {
    if (value == undefined) return false;
    return value instanceof File;
}
